exports.components = {
  "component---src-components-page-index-tsx": () => import("./../../../src/components/page/index.tsx" /* webpackChunkName: "component---src-components-page-index-tsx" */)
}

